import React, { useState, useEffect } from 'react';
import './gallery.css';


const generateGalleryImages = () => {
  const images = [];
  for (let i = 1; i <= 46; i++) {
    images.push(`galleryImage${i}.jpeg`);
  }
  return images;
};

const galleryImages = generateGalleryImages();

const GalleryModal = ({ open, src, onClose }) => {
  if (!open) return null;
  return (
    <div className="gallery-modal-overlay" onClick={onClose}>
      <div className="gallery-modal-content" onClick={e => e.stopPropagation()}>
        <button className="gallery-modal-close" onClick={onClose}>&times;</button>
        <img src={src} alt="Full view" className="gallery-modal-img" />
      </div>
    </div>
  );
};

const OurGallery = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImg, setModalImg] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  
  const imagesPerPage = 9;
  const totalImages = galleryImages.length;
  const itemWidth = 280;
  const gap = 8;
  const scrollAmount = (itemWidth + gap) * 3;

  const openModal = (img) => {
    setModalImg(`/Gallery/${img}`);
    setModalOpen(true);
  };

  const scrollToNext = () => {
    const totalWidth = totalImages * (itemWidth + gap);
    const maxScroll = totalWidth / 8;
    const nextPosition = scrollPosition + scrollAmount;
    

    if (nextPosition >= maxScroll) {
      setShowEndIndicator(prev => ({ ...prev, right: true }));
      setTimeout(() => setShowEndIndicator(prev => ({ ...prev, right: false })), 1000);
      return;
    }
    
    setShowEndIndicator(prev => ({ ...prev, right: false }));
    setScrollPosition(nextPosition);
  };

  const scrollToPrev = () => {
    const prevPosition = scrollPosition - scrollAmount;
    
    if (prevPosition < 0) {
      setShowEndIndicator(prev => ({ ...prev, left: true }));
      setTimeout(() => setShowEndIndicator(prev => ({ ...prev, left: false })), 1000);
      return;
    }
    
    setShowEndIndicator(prev => ({ ...prev, left: false }));
    setScrollPosition(prevPosition);
  };

  const isAtStart = scrollPosition === 0;
  const totalWidth = totalImages * (itemWidth + gap);
  const maxScroll = totalWidth / 8;
  const isAtEnd = scrollPosition >= maxScroll;
  
  
  const [showEndIndicator, setShowEndIndicator] = useState({ left: false, right: false });

  
  useEffect(() => {
    const gridElement = document.querySelector('.gallery-grid');
    if (gridElement) {
      gridElement.style.transform = `translateX(-${scrollPosition}px)`;
    }
  }, [scrollPosition]);

  return (
    <>
      {/* Page Header for SEO and Google Ads Compliance */}
      <header className="page-header" style={{
        background: 'linear-gradient(135deg, #561314 0%, #8B0000 100%)',
        color: 'white',
        textAlign: 'center',
        padding: '2rem 1rem',
        marginBottom: '0'
      }}>
        <h1 style={{
          fontSize: '2.5rem',
          margin: '0 0 1rem 0',
          fontWeight: '600',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        }}>
          Photo Gallery - Rameshwaram Villa Luxury Accommodation
        </h1>
        <p style={{
          fontSize: '1.2rem',
          margin: '0',
          maxWidth: '800px',
          marginLeft: 'auto',
          marginRight: 'auto',
          lineHeight: '1.6',
          opacity: '0.95'
        }}>
          Explore our stunning photo collection showcasing the luxury amenities, beautiful interiors, and breathtaking views 
          of Rameshwaram Villa. See why we're the premier choice for luxury accommodation in Pathankot.
        </p>
      </header>
      
      <section className="gallery-section">
        <h2 className="gallery-title">Our Photo Collection</h2>
        <p className="gallery-desc">Explore our curated collection of stunning images that showcase the beauty and creativity of our work. Each picture tells a unique story, capturing memorable moments and inspiring visuals for you to enjoy.</p>
      
      <div className="gallery-container">
        <button 
          className={`gallery-nav-btn gallery-nav-left ${isAtStart ? 'disabled' : ''}`}
          onClick={scrollToPrev}
          aria-label="Previous images"
          disabled={isAtStart}
        >
          ‹
        </button>
        
        <div className={`gallery-scroll-container ${showEndIndicator.left ? 'end-left' : ''} ${showEndIndicator.right ? 'end-right' : ''}`}>
          <div className="gallery-grid">
            {galleryImages.map((img, idx) => (
              <div className="gallery-item" key={img}>
                <img 
                  src={`/Gallery/${img}`} 
                  alt={`Gallery ${idx + 1}`} 
                  className="gallery-img" 
                  onClick={() => openModal(img)} 
                  style={{cursor:'pointer'}} 
                />
                <div className="gallery-overlay" onClick={() => openModal(img)} style={{cursor:'pointer'}}></div>
              </div>
            ))}
          </div>
        </div>
        
        <button 
          className={`gallery-nav-btn gallery-nav-right ${isAtEnd ? 'disabled' : ''}`}
          onClick={scrollToNext}
          aria-label="Next images"
          disabled={isAtEnd}
        >
          ›
        </button>
      </div>
      

      
      <GalleryModal open={modalOpen} src={modalImg} onClose={() => setModalOpen(false)} />
    </section>
    </>
  );
};

export default OurGallery;